import React from 'react';
import { Outlet } from 'react-router-dom';
import { PrivateRoute } from '../../components/HasRights/HasRights';
import { Permissions } from '../../const/permissions';
import { FEATURE_SHOW_OLD_NEWS } from '../../const/features';
import { FEATURES_SOURCE_MAP } from '../../domains/Featured/pages/PageFeatures/PageFeatures.const';
import { FEEDS_SOURCE_MAP } from '../../domains/Content/pages/Feeds/PageFeeds.const';
import { CATEGORIES_SOURCE } from '../../domains/Content/pages/Categories/PageCategories/PageCategories.const';
import { COLLECTIONS_SOURCE } from '../../domains/Content/pages/Collections/PageCollections/PageCollections.const';
import { NEWS_DICT_STRUCTURE } from '../../domains/Content/pages/News/PageDynamicNews/PageDynamicNews.const';
import { POPUPS_SOURCE } from '../../domains/Other/pages/Popups/PagePopups/PagePopups.const';
import { LOCAL_NOTIFICATIONS_SOURCE } from '../../domains/Other/pages/Notitications/Local/PageLocalNotifications/PageLocalNotifications.const';
import { PUSH_NOTIFICATIONS_SOURCE } from '../../domains/Other/pages/Notitications/Push/PagePushNotifications/PagePushNotifications.const';
import { dictionariesRoutes } from './DictionariesRoutes';
import urlPageLogin from '../../urls/urlPageLogin';
import urlPageProfile from '../../urls/urlPageProfile';
import urlPageRBACUsers from '../../urls/urlPageRBACUsers';
import urlPageRBACUserDetails from '../../urls/urlPageRBACUserDetails';
import urlPageRBACPermissions from '../../urls/urlPageRBACPermissions';
import urlPageRBACRoles from '../../urls/urlPageRBACRoles';
import urlPageRBACRoleDetails from '../../urls/urlPageRBACRoleDetails';
import urlPageLanguages from '../../urls/urlPageLanguages';
import urlPageStructures from '../../urls/urlPageStructures';
import urlPageStructuresEdit from '../../urls/urlPageStructuresEdit';
import urlPageDictionaries from '../../urls/urlPageDictionaries';
import urlPagePushIcons from '../../urls/urlPagePushIcons';
import urlPageDeeplinks from '../../urls/urlPageDeeplinks';
import urlPageNews from '../../urls/urlPageNews';
import urlPageImages from '../../urls/urlPageImages';
import urlPageImagesReserveStatistics from '../../urls/urlPageImagesReserveStatistics';
import urlPageImagesReserveStatisticsEdit from '../../urls/urlPageImagesReserveStatisticsEdit';
import urlPageImagesReserveStatisticsReference from '../../urls/urlPageImagesReserveStatisticsReference';
import urlPageImagesReserveStatisticsReferenceEdit from '../../urls/urlPageImagesReserveStatisticsReferenceEdit';
import urlPageNewsPriority from '../../urls/urlPageNewsPriority';
import urlPageTemplates from '../../urls/urlPageTemplates';
import urlPageTemplatesVisualizations from '../../urls/urlPageTemplatesVisualizations';
import urlPageTemplatesVisualizationsCreate from '../../urls/urlPageTemplatesVisualizationsCreate';
import urlPageTemplatesVisualizationsEdit from '../../urls/urlPageTemplatesVisualizationsEdit';
import urlPageTemplatesVisualizationsDetails from '../../urls/urlPageTemplatesVisualizationsDetails';
import urlPageCreateTemplate from '../../urls/urlPageCreateTemplate';
import urlPageDynamicNews from '../../urls/urlPageDynamicNews';
import urlPageDynamicNewsDetails from '../../urls/urlPageDynamicNewsDetails';
import urlPageEditTemplate from '../../urls/urlPageEditTemplate';
import urlPageTemplateDetails from '../../urls/urlPageTemplateDetails';
import urlPageDynamicNewsCreate from '../../urls/urlPageDynamicNewsCreate';
import urlPageDynamicNewsEdit from '../../urls/urlPageDynamicNewsEdit';
import urlPageDynamicNewsPriority from '../../urls/urlPageDynamicNewsPriority';
import urlPageCategories from '../../urls/urlPageCategories';
import urlPageAchievements from '../../urls/urlPageAchievements';
import urlPageCategoryCreate from '../../urls/urlPageCategoryCreate';
import urlPageCategoryEdit from '../../urls/urlPageCategoryEdit';
import urlPageCategoryDetails from '../../urls/urlPageCategoryDetails';
import urlPageCategoriesPriority from '../../urls/urlPageCategoriesPriority';
import urlPageAchievementsEdit from '../../urls/urlPageAchievementsEdit';
import urlPageAchievementsDetails from '../../urls/urlPageAchievementsDetails';
import urlPageFeatures from '../../urls/urlPageFeatures';
import urlPageFeatureCreate from '../../urls/urlPageFeatureCreate';
import urlPageFeatureDetails from '../../urls/urlPageFeatureDetails';
import urlPageFeaturesEdit from '../../urls/urlPageFeaturesEdit';
import urlPageFeaturePriorities from '../../urls/urlPageFeaturePriorities';
import urlPagePresets from '../../urls/urlPagePresets';
import urlPagePresetDetails from '../../urls/urlPagePresetDetails';
import urlPageCreatePreset from '../../urls/urlPageCreatePreset';
import urlPagePresetEdit from '../../urls/urlPagePresetEdit';
import urlPagePopups from '../../urls/urlPagePopups';
import urlPagePopupsDetails from '../../urls/urlPagePopupsDetails';
import urlPagePopupCreate from '../../urls/urlPagePopupCreate';
import urlPagePopupEdit from '../../urls/urlPagePopupEdit';
import urlPagePopupsPriority from '../../urls/urlPagePopupsPriority';
import urlPageBonuses from '../../urls/urlPageBonuses';
import urlPageBonusDetails from '../../urls/urlPageBonusDetails';
import urlPageBonusEdit from '../../urls/urlPageBonusEdit';
import urlPageRBACLogs from '../../urls/urlPageRBACLogs';
import urlPageRBACLogDetails from '../../urls/urlPageRBACLogDetails';
import urlPageCollections from '../../urls/urlPageCollections';
import urlPageCollectionCreate from '../../urls/urlPageCollectionCreate';
import urlPageCollectionEdit from '../../urls/urlPageCollectionEdit';
import urlPageCollectionDetails from '../../urls/urlPageCollectionDetails';
import urlPageCollectionPriority from '../../urls/urlPageCollectionPriority';
import urlPageFeeds from '../../urls/urlPageFeeds';
import urlPageFeedsPlanningDetails from '../../urls/urlPageFeedsPlanningDetails';
import urlPageFeedsPlanningDetailsEdit from '../../urls/urlPageFeedsPlanningDetailsEdit';
import urlPageResetStaticContentLogs from '../../urls/urlPageResetStaticContentLogs';
import urlPageLocalNotifications from '../../urls/urlPageLocalNotifications';
import urlPageLocalNotificationCreate from '../../urls/urlPageLocalNotificationCreate';
import urlPageLocalNotificationEdit from '../../urls/urlPageLocalNotificationEdit';
import urlPageLocalNotificationDetails from '../../urls/urlPageLocalNotificationDetails';
import urlPagePushNotifications from '../../urls/urlPagePushNotifications';
import urlPagePushNotificationCreate from '../../urls/urlPagePushNotificationCreate';
import urlPagePushNotificationEdit from '../../urls/urlPagePushNotificationEdit';
import urlPagePushNotificationDetails from '../../urls/urlPagePushNotificationDetails';
import urlPagePushNotificationsSchedule from '../../urls/urlPagePushNotificationsSchedule';
import urlPagePushNotificationScheduleCreate from '../../urls/urlPagePushNotificationScheduleCreate';
import urlPagePushNotificationScheduleEdit from '../../urls/urlPagePushNotificationScheduleEdit';
import urlPagePushNotificationScheduleDetails from '../../urls/urlPagePushNotificationScheduleDetails';
import urlPagePushNotificationScheduleClone from '../../urls/urlPagePushNotificationScheduleClone';
import Error404 from '../../components/Errors/404';
import PageLogin from '../../domains/Auth/pages/PageLogin';
import VerticalLayout from '../../layout/VerticalLayout';
import RequireAuth from '../../domains/Auth/components/RequireAuth';
import PageUsers from '../../domains/RBAC/pages/Users/PageUsers';
import PageProfile from '../../domains/Profile/pages/PageProfile';
import PagePersonalInformation from '../../domains/Profile/pages/PagePersonalInformation';
import PageUserDetails from '../../domains/RBAC/pages/Users/PageUserDetails';
import PagePermissions from '../../domains/RBAC/pages/Permissions/PagePermissions';
import PageRoles from '../../domains/RBAC/pages/Roles/PageRoles';
import PageRoleDetails from '../../domains/RBAC/pages/Roles/PageRoleDetails';
import PageLanguages from '../../domains/Translations/pages/Languages/PageLanguages/PageLanguages';
import PageStructures from '../../domains/Translations/pages/Structures/PageStructures';
import PageStructuresDetails from '../../domains/Translations/pages/Structures/PageStructuresDetails';
import PagePushIcons from '../../domains/Other/pages/Push icons/PagePushIcons';
import PageImages from '../../domains/Content/pages/Images/PageImages';
import PageImagesReserveStatistics from '../../domains/Content/pages/Images/PageImagesReserveStatistics';
import PageImagesReserveStatisticsReference from '../../domains/Content/pages/Images/PageImagesReserveStatisticsReference';
import PageDeeplinks from '../../domains/Other/pages/Deeplinks/PageDeeplinks';
import PageNews from '../../domains/Content/pages/Old news/PageNews';
import PageNewsPriority from '../../domains/Content/pages/Old news/PageNewsPriority';
import PageImagesCompressed from '../../domains/Content/pages/Images/PageImagesCompressed';
import PageTemplates from '../../domains/Template builder/pages/Templates/PageTemplates';
import PageTemplatesVisualizations from '../../domains/Template builder/pages/Templates/PageTemplatesVisualizations';
import PageCreateEditTemplatesVisualization from '../../domains/Template builder/pages/Templates/PageCreateEditTemplatesVisualization';
import PageTemplatesVisualizationDetails from '../../domains/Template builder/pages/Templates/PageTemplatesVisualizationDetails';
import PageTemplateDetails from '../../domains/Template builder/pages/Templates/PageTemplateDetails';
import PageCreateEditTemplate from '../../domains/Template builder/pages/Templates/PageCreateEditTemplate';
import PageDynamicNews from '../../domains/Content/pages/News/PageDynamicNews';
import PageDynamicNewsDetails from '../../domains/Content/pages/News/PageDynamicNewsDetails';
import PageDynamicNewsCreate from '../../domains/Content/pages/News/PageDynamicNewsCreate';
import PageDynamicNewsEdit from '../../domains/Content/pages/News/PageDynamicNewsEdit';
import PageDynamicNewsPriority from '../../domains/Content/pages/News/PageDynamicNewsPriority';
import PageAchievements from '../../domains/Content/pages/Achievements/PageAchievements';
import PageCategories from '../../domains/Content/pages/Categories/PageCategories';
import PageCreateCategory from '../../domains/Content/pages/Categories/PageCreateCategory';
import PageEditCategory from '../../domains/Content/pages/Categories/PageEditCategory';
import PageCategoryDetails from '../../domains/Content/pages/Categories/PageCategoryDetails';
import PageCategoriesPriority from '../../domains/Content/pages/Categories/PageCategoriesPriority';
import PageAchievementsEdit from '../../domains/Content/pages/Achievements/PageAchievementsEdit';
import PageAchievementDetails from '../../domains/Content/pages/Achievements/PageAchievementDetails';
import PageFeatures from '../../domains/Featured/pages/PageFeatures';
import PageFeatureCreate from '../../domains/Featured/pages/PageFeatureCreate';
import PageFeatureDetails from '../../domains/Featured/pages/PageFeatureDetails';
import PageFeaturesEdit from '../../domains/Featured/pages/PageFeaturesEdit';
import PageFeaturesPriority from '../../domains/Featured/pages/PageFeaturesPriority';
import PagePresets from '../../domains/Template builder/pages/Presets/PagePresets';
import PagePresetsCreate from '../../domains/Template builder/pages/Presets/PagePresetsCreate';
import PagePresetsEdit from '../../domains/Template builder/pages/Presets/PagePresetsEdit';
import PagePresetDetails from '../../domains/Template builder/pages/Presets/PagePresetDetails';
import PagePopups from '../../domains/Other/pages/Popups/PagePopups';
import PagePopupsDetails from '../../domains/Other/pages/Popups/PagePopupsDetails';
import PagePopupCreate from '../../domains/Other/pages/Popups/PagePopupCreate';
import PagePopupEdit from '../../domains/Other/pages/Popups/PagePopupEdit';
import PagePopupsPriority from '../../domains/Other/pages/Popups/PagePopupsPriority';
import PageBonuses from '../../domains/Content/pages/Bonuses/PageBonuses';
import PageBonusDetails from '../../domains/Content/pages/Bonuses/PageBonusDetails';
import PageBonusEdit from '../../domains/Content/pages/Bonuses/PageBonusEdit';
import PageLogs from '../../domains/RBAC/pages/Logs/PageLogs';
import PageLogDetails from '../../domains/RBAC/pages/Logs/PageLogDetails';
import PageCollections from '../../domains/Content/pages/Collections/PageCollections';
import PageCreateCollection from '../../domains/Content/pages/Collections/PageCreateCollection';
import PageEditCollection from '../../domains/Content/pages/Collections/PageEditCollection';
import PageCollectionDetails from '../../domains/Content/pages/Collections/PageCollectionDetails';
import PageCollectionPriority from '../../domains/Content/pages/Collections/PageCollectionPriority';
import PageFeedsList from '../../domains/Content/pages/Feeds/PageFeedsList';
import PageFeedsArchiveAndTrash from '../../domains/Content/pages/Feeds/PageFeedsArchiveAndTrash';
import PageFeedsReleased from '../../domains/Content/pages/Feeds/PageFeedsReleased';
import PageFeedsPlanning from '../../domains/Content/pages/Feeds/PageFeedsPlanning';
import PageFeedsPlanningDetails from '../../domains/Content/pages/Feeds/PageFeedsPlanningDetails';
import PageStaticContentResetLogs from '../../domains/Other/pages/StaticContentResetLogs/PageStaticContentResetLogs';
import PageLocalNotifications from '../../domains/Other/pages/Notitications/Local/PageLocalNotifications';
import PageCreateLocalNotification from '../../domains/Other/pages/Notitications/Local/PageCreateLocalNotification';
import PageEditLocalNotification from '../../domains/Other/pages/Notitications/Local/PageEditLocalNotification';
import PageLocalNotificationDetails from '../../domains/Other/pages/Notitications/Local/PageLocalNotificationDetails';
import PagePushNotifications from '../../domains/Other/pages/Notitications/Push/PagePushNotifications';
import PageCreatePushNotification from '../../domains/Other/pages/Notitications/Push/PageCreatePushNotification';
import PageEditPushNotification from '../../domains/Other/pages/Notitications/Push/PageEditPushNotification';
import PagePushNotificationDetails from '../../domains/Other/pages/Notitications/Push/PagePushNotificationDetails';
import PagePushNotificationsSchedule from '../../domains/Other/pages/Notitications/Push/PagePushNotificationsSchedule';
import PagePushNotificationScheduleDetails from '../../domains/Other/pages/Notitications/Push/PagePushNotificationScheduleDetails';
import PageCreatePushNotificationSchedule from '../../domains/Other/pages/Notitications/Push/PageCreatePushNotificationSchedule';
import PageEditPushNotificationSchedule from '../../domains/Other/pages/Notitications/Push/PageEditPushNotificationSchedule';



const routes = [
  {
    path: urlPageLogin(),
    element: <PageLogin />,
  },
  {
    path: '/',
    element: <RequireAuth><VerticalLayout /></RequireAuth>,
    children: [
      {
        path: urlPageImages(),
        element: <Outlet />,
        children: [
          {
            path: urlPageImages(),
            element: (
              <PrivateRoute allowedPermissions={[ Permissions.CONTENT.IMAGES.LIST ]}>
                <PageImages />
              </PrivateRoute>
            ),
          },
          {
            path: urlPageImagesReserveStatistics(),
            element: (
              <PrivateRoute allowedPermissions={[ Permissions.CONTENT.IMAGES.RESERVE_STATISTICS.LIST ]}>
                <PageImagesReserveStatistics />
              </PrivateRoute>
            ),
          },
          {
            path: urlPageImagesReserveStatisticsEdit(),
            element: (
              <PrivateRoute allowedPermissions={[ Permissions.CONTENT.IMAGES.RESERVE_STATISTICS.EDIT_TABLE_STRUCTURE ]}>
                <PageImagesReserveStatistics />
              </PrivateRoute>
            ),
          },
          {
            path: urlPageImagesReserveStatisticsReference(),
            element: (
              <PrivateRoute allowedPermissions={[ Permissions.CONTENT.IMAGES.RESERVE_STATISTICS.LIST ]}>
                <PageImagesReserveStatisticsReference />
              </PrivateRoute>
            ),
          },
          {
            path: urlPageImagesReserveStatisticsReferenceEdit(),
            element: (
              <PrivateRoute allowedPermissions={[ Permissions.CONTENT.IMAGES.RESERVE_STATISTICS.EDIT_REFERENCES ]}>
                <PageImagesReserveStatisticsReference />
              </PrivateRoute>
            ),
          },
        ],
      },
      {
        path: urlPageCategories(),
        element: <Outlet />,
        children: [
          {
            path: urlPageCategories(),
            element: (
              <PrivateRoute allowedPermissions={[ Permissions.CONTENT.CATEGORIES.LIST ]}>
                <PageCategories />
              </PrivateRoute>
            ),
          },
          {
            path: urlPageCategoryCreate(),
            element: (
              <PrivateRoute allowedPermissions={[ Permissions.CONTENT.CATEGORIES.CREATE ]}>
                <PageCreateCategory />
              </PrivateRoute>
            ),
          },
          {
            path: urlPageCategoryDetails(),
            element: (
              <PrivateRoute allowedPermissions={[ Permissions.CONTENT.CATEGORIES.VIEW ]}>
                <PageCategoryDetails />
              </PrivateRoute>
            ),
          },
          {
            path: urlPageCategoryEdit(),
            element: (
              <PrivateRoute allowedPermissions={[ Permissions.CONTENT.CATEGORIES.EDIT ]}>
                <PageEditCategory />
              </PrivateRoute>
            ),
          },
          ...dictionariesRoutes({ urlPrefix: CATEGORIES_SOURCE }),
        ],
      },
      {
        path: urlPageCategoriesPriority(),
        element: (
          <PrivateRoute allowedPermissions={[ Permissions.CONTENT.CATEGORIES.PRIORITIES.LIST ]}>
            <PageCategoriesPriority />
          </PrivateRoute>
        ),
      },
      {
        path: urlPageBonuses(),
        element: <Outlet />,
        children: [
          {
            path: urlPageBonuses(),
            element: (
              <PrivateRoute allowedPermissions={[ Permissions.CONTENT.BONUSES.LIST ]}>
                <PageBonuses />
              </PrivateRoute>
            ),
          },
          {
            path: urlPageBonusEdit(),
            element: (
              <PrivateRoute allowedPermissions={[ Permissions.CONTENT.BONUSES.EDIT ]}>
                <PageBonusEdit />
              </PrivateRoute>
            ),
          },
          {
            path: urlPageBonusDetails(),
            element: (
              <PrivateRoute allowedPermissions={[ Permissions.CONTENT.BONUSES.VIEW ]}>
                <PageBonusDetails />
              </PrivateRoute>
            ),
          },
        ],
      },
      {
        path: urlPageAchievements(),
        element: <Outlet />,
        children: [
          {
            path: urlPageAchievements(),
            element: (
              <PrivateRoute allowedPermissions={[ Permissions.CONTENT.ACHIEVEMENTS.LIST ]}>
                <PageAchievements />
              </PrivateRoute>
            ),
          },
          {
            path: urlPageAchievementsDetails(),
            element: (
              <PrivateRoute allowedPermissions={[ Permissions.CONTENT.ACHIEVEMENTS.VIEW ]}>
                <PageAchievementDetails />
              </PrivateRoute>
            ),
          },
          {
            path: urlPageAchievementsEdit(),
            element: (
              <PrivateRoute allowedPermissions={[ Permissions.CONTENT.ACHIEVEMENTS.EDIT ]}>
                <PageAchievementsEdit />
              </PrivateRoute>
            ),
          },
        ],
      },
      {
        path: urlPageCollections(),
        element: <Outlet />,
        children: [
          {
            path: urlPageCollections(),
            element: (
              <PrivateRoute allowedPermissions={[ Permissions.CONTENT.COLLECTIONS.LIST ]}>
                <PageCollections />
              </PrivateRoute>
            ),
          },
          {
            path: urlPageCollectionDetails(),
            element: (
              <PrivateRoute allowedPermissions={[ Permissions.CONTENT.COLLECTIONS.VIEW ]}>
                <PageCollectionDetails />
              </PrivateRoute>
            ),
          },
          {
            path: urlPageCollectionCreate(),
            element: (
              <PrivateRoute allowedPermissions={[ Permissions.CONTENT.COLLECTIONS.CREATE ]}>
                <PageCreateCollection />
              </PrivateRoute>
            ),
          },
          {
            path: urlPageCollectionEdit(),
            element: (
              <PrivateRoute allowedPermissions={[ Permissions.CONTENT.COLLECTIONS.EDIT ]}>
                <PageEditCollection />
              </PrivateRoute>
            ),
          },
          {
            path: urlPageCollectionPriority(),
            element: (
              <PrivateRoute allowedPermissions={[ Permissions.CONTENT.COLLECTIONS.PRIORITIES.LIST ]}>
                <PageCollectionPriority />
              </PrivateRoute>
            ),
          },
          ...dictionariesRoutes({ urlPrefix: COLLECTIONS_SOURCE }),
        ],
      },
      {
        path: '/compressed/cargo',
        element: (
          <PrivateRoute allowedPermissions={[ Permissions.CONTENT.IMAGES.LIST ]}>
            <PageImagesCompressed />
          </PrivateRoute>
        ),
      },
      {
        path: urlPageProfile(),
        element: <PageProfile />,
        children: [
          {
            path: urlPageProfile(),
            element: <PagePersonalInformation />,
          },
        ],
      },
      {
        path: urlPageRBACUsers(),
        element: <Outlet />,
        children: [
          {
            path: urlPageRBACUsers(),
            element: (
              <PrivateRoute allowedPermissions={[ Permissions.ADMINISTRATION.USERS.USERS_LIST.VIEW_PAGE ]}>
                <PageUsers />
              </PrivateRoute>
            ),
          },
          {
            path: urlPageRBACUserDetails(),
            element: (
              <PrivateRoute allowedPermissions={[ Permissions.ADMINISTRATION.USERS.USER_DETAILS.VIEW ]}>
                <PageUserDetails />
              </PrivateRoute>
            ),
          },
        ],
      },
      {
        path: urlPageRBACRoles(),
        element: <Outlet />,
        children: [
          {
            path: urlPageRBACRoles(),
            element: (
              <PrivateRoute allowedPermissions={[ Permissions.ADMINISTRATION.ROLES.ROLES_LIST.VIEW_PAGE ]}>
                <PageRoles />
              </PrivateRoute>
            ),
          },
          {
            path: urlPageRBACRoleDetails(),
            element: (
              <PrivateRoute allowedPermissions={[ Permissions.ADMINISTRATION.ROLES.ROLE_DETAILS.VIEW ]}>
                <PageRoleDetails />
              </PrivateRoute>
            ),
          },
        ],
      },
      {
        path: urlPageRBACPermissions(),
        element: (
          <PrivateRoute allowedPermissions={[ Permissions.ADMINISTRATION.PERMISSIONS.VIEW_LIST ]}>
            <PagePermissions />
          </PrivateRoute>
        ),
      },
      {
        path: urlPageRBACLogs(),
        element: <Outlet />,
        children: [
          {
            path: urlPageRBACLogs(),
            element: (
              <PrivateRoute allowedPermissions={[ Permissions.ADMINISTRATION.LOGS.LIST ]}>
                <PageLogs />
              </PrivateRoute>
            ),
          },
          {
            path: urlPageRBACLogDetails(),
            element: (
              <PrivateRoute allowedPermissions={[ Permissions.ADMINISTRATION.LOGS.DETAILS ]}>
                <PageLogDetails />
              </PrivateRoute>
            ),
          },
        ],
      },
      {
        path: urlPageLanguages(),
        element: (
          <PrivateRoute allowedPermissions={[ Permissions.TRANSLATIONS.LANGUAGES.LANGUAGES_LIST.VIEW_PAGE ]}>
            <PageLanguages />
          </PrivateRoute>
        ),
      },
      {
        path: urlPageStructures(),
        element: <Outlet />,
        children: [
          {
            path: urlPageStructures(),
            element: (
              <PrivateRoute allowedPermissions={[ Permissions.TRANSLATIONS.STRUCTURES.LIST.VIEW_PAGE ]}>
                <PageStructures />
              </PrivateRoute>
            ),
          },
          {
            path: urlPageStructuresEdit(),
            element: (
              <PrivateRoute
                allowedPermissions={[
                  Permissions.TRANSLATIONS.STRUCTURES.DETAILS.EDIT,
                  Permissions.TRANSLATIONS.STRUCTURES.DETAILS.GET,
                ]}
              >
                <PageStructuresDetails />
              </PrivateRoute>
            ),
          },
        ],
      },
      {
        path: urlPageDictionaries(),
        element: <Outlet />,
        children: [ ...dictionariesRoutes({}) ],
      },
      {
        path: urlPagePushIcons(),
        element: (
          <PrivateRoute allowedPermissions={[ Permissions.OTHER.PUSH_ICONS.LIST.VIEW ]}>
            <PagePushIcons />
          </PrivateRoute>
        ),
      },
      {
        path: urlPageDeeplinks(),
        element: (
          <PrivateRoute allowedPermissions={[ Permissions.OTHER.DEEPLINKS.LIST ]}>
            <PageDeeplinks />
          </PrivateRoute>
        ),
      },
      {
        path: urlPageLocalNotifications(),
        element: <Outlet />,
        children: [
          {
            path: urlPageLocalNotifications(),
            element: (
              <PrivateRoute allowedPermissions={[ Permissions.OTHER.NOTIFICATIONS.LOCAL.LIST ]}>
                <PageLocalNotifications />
              </PrivateRoute>
            ),
          },
          {
            path: urlPageLocalNotificationCreate(),
            element: (
              <PrivateRoute allowedPermissions={[ Permissions.OTHER.NOTIFICATIONS.LOCAL.CREATE ]}>
                <PageCreateLocalNotification />
              </PrivateRoute>
            ),
          },
          {
            path: urlPageLocalNotificationEdit(),
            element: (
              <PrivateRoute allowedPermissions={[ Permissions.OTHER.NOTIFICATIONS.LOCAL.EDIT ]}>
                <PageEditLocalNotification />
              </PrivateRoute>
            ),
          },
          {
            path: urlPageLocalNotificationDetails(),
            element: (
              <PrivateRoute allowedPermissions={[ Permissions.OTHER.NOTIFICATIONS.LOCAL.FIND ]}>
                <PageLocalNotificationDetails />
              </PrivateRoute>
            ),
          },
          ...dictionariesRoutes({ urlPrefix: LOCAL_NOTIFICATIONS_SOURCE }),
        ],
      },
      {
        path: urlPagePushNotifications(),
        element: <Outlet />,
        children: [
          {
            path: urlPagePushNotifications(),
            element: (
              <PrivateRoute allowedPermissions={[ Permissions.OTHER.NOTIFICATIONS.PUSH.LIST ]}>
                <PagePushNotifications />
              </PrivateRoute>
            ),
          },
          {
            path: urlPagePushNotificationCreate(),
            element: (
              <PrivateRoute allowedPermissions={[ Permissions.OTHER.NOTIFICATIONS.PUSH.CREATE ]}>
                <PageCreatePushNotification />
              </PrivateRoute>
            ),
          },
          {
            path: urlPagePushNotificationEdit(),
            element: (
              <PrivateRoute allowedPermissions={[ Permissions.OTHER.NOTIFICATIONS.PUSH.EDIT ]}>
                <PageEditPushNotification />
              </PrivateRoute>
            ),
          },
          {
            path: urlPagePushNotificationDetails(),
            element: (
              <PrivateRoute allowedPermissions={[ Permissions.OTHER.NOTIFICATIONS.PUSH.FIND ]}>
                <PagePushNotificationDetails />
              </PrivateRoute>
            ),
          },
          ...dictionariesRoutes({ urlPrefix: PUSH_NOTIFICATIONS_SOURCE }),
        ],
      },
      {
        path: urlPagePushNotificationsSchedule(),
        element: <Outlet />,
        children: [
          {
            path: urlPagePushNotificationsSchedule(),
            element: (
              <PrivateRoute allowedPermissions={[ Permissions.OTHER.NOTIFICATIONS.PUSH.SCHEDULE.LIST ]}>
                <PagePushNotificationsSchedule />
              </PrivateRoute>
            ),
          },
          {
            path: urlPagePushNotificationScheduleCreate(),
            element: (
              <PrivateRoute allowedPermissions={[ Permissions.OTHER.NOTIFICATIONS.PUSH.SCHEDULE.CREATE ]}>
                <PageCreatePushNotificationSchedule />
              </PrivateRoute>
            ),
          },
          {
            path: urlPagePushNotificationScheduleClone(),
            element: (
              <PrivateRoute allowedPermissions={[ Permissions.OTHER.NOTIFICATIONS.PUSH.SCHEDULE.CREATE ]}>
                <PageCreatePushNotificationSchedule />
              </PrivateRoute>
            ),
          },
          {
            path: urlPagePushNotificationScheduleEdit(),
            element: (
              <PrivateRoute allowedPermissions={[ Permissions.OTHER.NOTIFICATIONS.PUSH.SCHEDULE.EDIT ]}>
                <PageEditPushNotificationSchedule />
              </PrivateRoute>
            ),
          },
          {
            path: urlPagePushNotificationScheduleDetails(),
            element: (
              <PrivateRoute allowedPermissions={[ Permissions.OTHER.NOTIFICATIONS.PUSH.SCHEDULE.FIND ]}>
                <PagePushNotificationScheduleDetails />
              </PrivateRoute>
            ),
          },
        ],
      },
      {
        path: urlPagePopups(),
        element: <Outlet />,
        children: [
          {
            path: urlPagePopups(),
            element: (
              <PrivateRoute allowedPermissions={[ Permissions.OTHER.POPUPS.LIST ]}>
                <PagePopups />
              </PrivateRoute>
            ),
          },
          {
            path: urlPagePopupCreate(),
            element: (
              <PrivateRoute allowedPermissions={[ Permissions.OTHER.POPUPS.CREATE ]}>
                <PagePopupCreate />
              </PrivateRoute>
            ),
          },
          {
            path: urlPagePopupsDetails(),
            element: (
              <PrivateRoute allowedPermissions={[ Permissions.OTHER.POPUPS.FIND ]}>
                <PagePopupsDetails />
              </PrivateRoute>
            ),
          },
          {
            path: urlPagePopupEdit(),
            element: (
              <PrivateRoute allowedPermissions={[ Permissions.OTHER.POPUPS.EDIT ]}>
                <PagePopupEdit />
              </PrivateRoute>
            ),
          },
          {
            path: urlPagePopupsPriority(),
            element: (
              <PrivateRoute allowedPermissions={[ Permissions.OTHER.POPUPS.PRIORITY.LIST ]}>
                <PagePopupsPriority />
              </PrivateRoute>
            ),
          },
          ...dictionariesRoutes({ urlPrefix: POPUPS_SOURCE }),
        ],
      },
      {
        path: urlPageResetStaticContentLogs(),
        element: (
          <PrivateRoute allowedPermissions={[ Permissions.OTHER.STATIC_CONTENT_RESET.LIST ]}>
            <PageStaticContentResetLogs />
          </PrivateRoute>
        ),
      },
      {
        path: urlPageDynamicNews(),
        element: <Outlet />,
        children: [
          {
            path: urlPageDynamicNews(),
            element: (
              <PrivateRoute allowedPermissions={[ Permissions.CONTENT.NEWS.LIST ]}>
                <PageDynamicNews />
              </PrivateRoute>
            ),
          },
          {
            path: urlPageDynamicNewsCreate(),
            element: (
              <PrivateRoute allowedPermissions={[ Permissions.CONTENT.NEWS.CREATE ]}>
                <PageDynamicNewsCreate />
              </PrivateRoute>
            ),
          },
          {
            path: urlPageDynamicNewsDetails(),
            element: (
              <PrivateRoute allowedPermissions={[ Permissions.CONTENT.NEWS.FIND ]}>
                <PageDynamicNewsDetails />
              </PrivateRoute>
            ),
          },
          {
            path: urlPageDynamicNewsEdit(),
            element: (
              <PrivateRoute allowedPermissions={[ Permissions.CONTENT.NEWS.EDIT ]}>
                <PageDynamicNewsEdit />
              </PrivateRoute>
            ),
          },
          {
            path: urlPageDynamicNewsPriority(),
            element: (
              <PrivateRoute allowedPermissions={[ Permissions.CONTENT.NEWS.PRIORITY ]}>
                <PageDynamicNewsPriority />
              </PrivateRoute>
            ),
          },
          ...dictionariesRoutes({ urlPrefix: NEWS_DICT_STRUCTURE }),
        ],
      },
      ...FEATURE_SHOW_OLD_NEWS ? [ {
        path: urlPageNews(),
        element: <Outlet />,
        children: [
          {
            path: urlPageNews(),
            element: (
              <PrivateRoute allowedPermissions={[ Permissions.CONTENT.NEWS.LIST ]}>
                <PageNews />
              </PrivateRoute>
            ),
          },
          {
            path: urlPageNewsPriority(),
            element: (
              <PrivateRoute allowedPermissions={[ Permissions.CONTENT.NEWS.PRIORITY ]}>
                <PageNewsPriority />
              </PrivateRoute>
            ),
          },
        ],
      } ] : [],

      {
        path: urlPageFeeds({ feedSource: FEEDS_SOURCE_MAP.ARCHIVED }),
        element: (
          <PrivateRoute allowedPermissions={[ Permissions.CONTENT.FEEDS.ARCHIVED ]}>
            <PageFeedsArchiveAndTrash />
          </PrivateRoute>
        ),
      },
      {
        path: urlPageFeeds({ feedSource: FEEDS_SOURCE_MAP.TRASHED }),
        element: (
          <PrivateRoute allowedPermissions={[ Permissions.CONTENT.FEEDS.TRASHED ]}>
            <PageFeedsArchiveAndTrash />
          </PrivateRoute>
        ),
      },
      {
        path: urlPageFeeds({ feedSource: FEEDS_SOURCE_MAP.LIST }),
        element: (
          <PrivateRoute allowedPermissions={[ Permissions.CONTENT.FEEDS.LIST ]}>
            <PageFeedsList />
          </PrivateRoute>
        ),
      },
      {
        path: urlPageFeeds({ feedSource: FEEDS_SOURCE_MAP.RELEASED }),
        element: (
          <PrivateRoute allowedPermissions={[ Permissions.CONTENT.FEEDS.RELEASED ]}>
            <PageFeedsReleased />
          </PrivateRoute>
        ),
      },
      {
        path: urlPageFeeds({ feedSource: FEEDS_SOURCE_MAP.PLANNING }),
        element: (
          <PrivateRoute allowedPermissions={[ Permissions.CONTENT.FEEDS.PLANNING.STORAGE, Permissions.CONTENT.FEEDS.PLANNING.BOARD.LIST ]}>
            <PageFeedsPlanning />
          </PrivateRoute>
        ),
      },
      {
        path: urlPageFeedsPlanningDetails({ feedSource: FEEDS_SOURCE_MAP.PLANNING }),
        element: (
          <PrivateRoute allowedPermissions={[ Permissions.CONTENT.FEEDS.PLANNING.STORAGE, Permissions.CONTENT.FEEDS.PLANNING.BOARD.DETAILS ]}>
            <PageFeedsPlanningDetails />
          </PrivateRoute>
        ),
      },
      {
        path: urlPageFeedsPlanningDetailsEdit({ feedSource: FEEDS_SOURCE_MAP.PLANNING }),
        element: (
          <PrivateRoute
            isMultipleAllowance
            allowedPermissions={[
              Permissions.CONTENT.FEEDS.PLANNING.BOARD.DETAILS,
              Permissions.CONTENT.FEEDS.PLANNING.BOARD.PUBLISH,
            ]}
          >
            <PageFeedsPlanningDetails />
          </PrivateRoute>
        ),
      },

      ...Object.values(FEATURES_SOURCE_MAP).map((featureSource, index) => {
        const sourceKey = Object.keys(FEATURES_SOURCE_MAP)[index];

        return {
          path: urlPageFeatures({ featureSource }),
          element: <Outlet />,
          children: [
            {
              path: urlPageFeatures({ featureSource }),
              element: (
                <PrivateRoute allowedPermissions={[ Permissions.FEATURED.FEATURES[sourceKey].LIST ]}>
                  <PageFeatures />
                </PrivateRoute>
              ),
            },
            {
              path: urlPageFeatureCreate({ featureSource }),
              element: (
                <PrivateRoute allowedPermissions={[ Permissions.FEATURED.FEATURES[sourceKey].CREATE ]}>
                  <PageFeatureCreate />
                </PrivateRoute>
              ),
            },
            {
              path: urlPageFeatureDetails({ featureSource }),
              element: (
                <PrivateRoute allowedPermissions={[ Permissions.FEATURED.FEATURES[sourceKey].FIND ]}>
                  <PageFeatureDetails />
                </PrivateRoute>
              ),
            },
            {
              path: urlPageFeaturesEdit({ featureSource }),
              element: (
                <PrivateRoute allowedPermissions={[ Permissions.FEATURED.FEATURES[sourceKey].EDIT ]}>
                  <PageFeaturesEdit />
                </PrivateRoute>
              ),
            },
            ...dictionariesRoutes({ urlPrefix: FEATURES_SOURCE_MAP[sourceKey] }),
          ],
        };
      }),
      {
        path: urlPageFeaturePriorities(),
        element: (
          <PrivateRoute allowedPermissions={[ Permissions.FEATURED.FEATURES.PRIORITY.LIST ]}>
            <PageFeaturesPriority />
          </PrivateRoute>
        ),
      },
      {
        path: urlPagePresets(),
        element: <Outlet />,
        children: [
          {
            path: urlPagePresets(),
            element: (
              <PrivateRoute allowedPermissions={[ Permissions.CONSTRUCTORS.PRESETS.LIST ]}>
                <PagePresets />
              </PrivateRoute>
            ),
          },
          {
            path: urlPageCreatePreset(),
            element: (
              <PrivateRoute allowedPermissions={[ Permissions.CONSTRUCTORS.PRESETS.CREATE ]}>
                <PagePresetsCreate />
              </PrivateRoute>
            ),
          },
          {
            path: urlPagePresetEdit(),
            element: (
              <PrivateRoute allowedPermissions={[ Permissions.CONSTRUCTORS.PRESETS.EDIT ]}>
                <PagePresetsEdit />
              </PrivateRoute>
            ),
          },
          {
            path: urlPagePresetDetails(),
            element: (
              <PrivateRoute allowedPermissions={[ Permissions.CONSTRUCTORS.PRESETS.FIND ]}>
                <PagePresetDetails />
              </PrivateRoute>
            ),
          },
        ],
      },
      {
        path: urlPageTemplates(),
        element: <Outlet />,
        children: [
          {
            path: urlPageTemplates(),
            element: (
              <PrivateRoute allowedPermissions={[ Permissions.CONSTRUCTORS.TEMPLATES.LIST ]}>
                <PageTemplates />
              </PrivateRoute>
            ),
          },
          {
            path: urlPageCreateTemplate(),
            element: (
              <PrivateRoute allowedPermissions={[ Permissions.CONSTRUCTORS.TEMPLATES.CREATE ]}>
                <PageCreateEditTemplate />
              </PrivateRoute>
            ),
          },
          {
            path: urlPageTemplateDetails(),
            element: (
              <PrivateRoute allowedPermissions={[ Permissions.CONSTRUCTORS.TEMPLATES.FIND ]}>
                <PageTemplateDetails />
              </PrivateRoute>
            ),
          },
          {
            path: urlPageEditTemplate(),
            element: (
              <PrivateRoute
                allowedPermissions={[
                  Permissions.CONSTRUCTORS.TEMPLATES.FIND,
                  Permissions.CONSTRUCTORS.TEMPLATES.EDIT,
                ]}
              >
                <PageCreateEditTemplate />
              </PrivateRoute>
            ),
          },
        ],
      },
      {
        path: urlPageTemplatesVisualizations(),
        element: <Outlet />,
        children: [
          {
            path: urlPageTemplatesVisualizations(),
            element: (
              <PrivateRoute allowedPermissions={[ Permissions.CONSTRUCTORS.TEMPLATES.VISUALIZATIONS.LIST ]}>
                <PageTemplatesVisualizations />
              </PrivateRoute>
            ),
          },
          {
            path: urlPageTemplatesVisualizationsCreate(),
            element: (
              <PrivateRoute allowedPermissions={[ Permissions.CONSTRUCTORS.TEMPLATES.VISUALIZATIONS.CREATE ]}>
                <PageCreateEditTemplatesVisualization />
              </PrivateRoute>
            ),
          },
          {
            path: urlPageTemplatesVisualizationsDetails(),
            element: (
              <PrivateRoute allowedPermissions={[ Permissions.CONSTRUCTORS.TEMPLATES.VISUALIZATIONS.VIEW ]}>
                <PageTemplatesVisualizationDetails />
              </PrivateRoute>
            ),
          },
          {
            path: urlPageTemplatesVisualizationsEdit(),
            element: (
              <PrivateRoute allowedPermissions={[ Permissions.CONSTRUCTORS.TEMPLATES.VISUALIZATIONS.EDIT ]}>
                <PageCreateEditTemplatesVisualization />
              </PrivateRoute>
            ),
          },
        ],
      },
    ],
  },
  { path: '*', element: <Error404 /> },
];

export default routes;
